import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../../config/config';
import {HelpInfo} from '../../../models/help-info.interface';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {EditDialogComponent} from '../../dialogs/edit-dialog/edit-dialog.component';

@Component({
  selector: 'app-chart-labels-table',
  templateUrl: './chart-labels-table.component.html',
  styleUrls: ['./chart-labels-table.component.scss']
})
export class ChartLabelsTableComponent implements AfterViewInit {


  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['id', 'code', 'title', 'edit'];

  @Input()
  chartLabels!: HelpInfo[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadChartLabels: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly dialog: MatDialog) { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadChartLabels.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadChartLabels.emit({page: event.pageIndex, size: event.pageSize});
  }

  editDialog(value: HelpInfo): void {
    const dialogRef = this.dialog.open(EditDialogComponent, { data: value, maxWidth: 600, width: 'inherit'});

    dialogRef.componentInstance.updateEvent.subscribe(() => {
      this.loadChartLabels.emit({page: this.paginator.pageIndex, size: this.paginator.pageSize});
    });
  }
}
